export const BUNDLE_PRODUCTS = '/bundleproducts/api/get-product-data-by-varient-key';